/* Drag&Drop global bridge loader + dedicated designer routing · locale-safe 2026-09-11 */
(function(){
  'use strict';
  var VERSION='2026-09-29-designer-login-routing-v4';
  if(window.__ddDedicatedDesignerRouting===VERSION)return;
  window.__ddDedicatedDesignerRouting=VERSION;

  var ACTIVE_LOCALE=String(document.documentElement.lang||'tr').toLowerCase().split('-')[0];
  var STOREFRONT_LOCALES=['en','es','ru','ar'];
  var LOCALE_PREFIX=STOREFRONT_LOCALES.indexOf(ACTIVE_LOCALE)>-1?'/'+ACTIVE_LOCALE:'';
  var LOCALE_RE=/^\/(en|es|ru|ar)(?=\/|$)/i;
  var DIRECT_PATHS={
    '/blogs/ilham':true,
    '/collections/sale':true,
    '/pages/hediye-rehberi':true,
    '/pages/kultur-sanat':true
  };
  var PANEL_LOGIN_URL='https://www.draganddrop.online/login?next=%2Fdesigner%2Fdashboard'; /* explicit designer destination avoids role/auth race */

  function isDesignerPanelAnchor(anchor){
    if(!anchor)return false;
    var href=String(anchor.getAttribute('href')||'').toLowerCase();
    var label=String(anchor.textContent||'').replace(/\s+/g,' ').trim().toLocaleLowerCase('tr-TR');
    return href.indexOf('draganddrop.online/designer')>-1 ||
      label==='tasarımcı paneli' ||
      label==='designer panel' ||
      anchor.hasAttribute('data-dd-designer-panel');
  }
  function normalizeDesignerPanelLinks(root){
    var scope=root||document;
    if(!scope.querySelectorAll)return;
    scope.querySelectorAll('a[href],a[data-dd-designer-panel]').forEach(function(anchor){
      if(!isDesignerPanelAnchor(anchor))return;
      anchor.setAttribute('href',PANEL_LOGIN_URL);
      anchor.removeAttribute('target');
      anchor.removeAttribute('rel');
      anchor.dataset.ddDesignerPanel='true';
    });
  }
  document.addEventListener('click',function(event){
    if(!event.target||!event.target.closest)return;
    var anchor=event.target.closest('a[href],a[data-dd-designer-panel]');
    if(!isDesignerPanelAnchor(anchor))return;
    event.preventDefault();
    event.stopPropagation();
    if(typeof event.stopImmediatePropagation==='function')event.stopImmediatePropagation();
    window.location.assign(PANEL_LOGIN_URL);
  },true);

  function cleanPath(value){return String(value||'').replace(/\/$/,'')||'/';}
  function stripLocalePath(value){
    var path=cleanPath(value);
    var stripped=path.replace(LOCALE_RE,'');
    return cleanPath(stripped||'/');
  }
  function localizePath(value){
    var raw=String(value||'');
    if(!raw)return '';
    try{
      var url=new URL(raw,window.location.origin);
      if(url.origin!==window.location.origin)return raw;
      if(LOCALE_RE.test(url.pathname))return url.pathname+url.search+url.hash;
      if(!/^\/(collections|products|pages|blogs)(?=\/|$)/i.test(url.pathname))return url.pathname+url.search+url.hash;
      return LOCALE_PREFIX+url.pathname+url.search+url.hash;
    }catch(error){return raw;}
  }
  function isDirectEditorial(value){
    try{return !!DIRECT_PATHS[stripLocalePath(new URL(value||'',window.location.origin).pathname)];}
    catch(error){return false;}
  }

  document.addEventListener('click',function(event){
    if(!event.target||!event.target.closest)return;
    var b2bButton=event.target.closest('[data-faire-switch-mode="b2b"],[data-dd-b2b-route]');
    if(b2bButton){
      event.preventDefault();
      event.stopPropagation();
      if(typeof event.stopImmediatePropagation==='function')event.stopImmediatePropagation();
      window.location.assign(LOCALE_PREFIX+'/pages/kurumsal-siparisler');
      return;
    }
    var directLink=event.target.closest('.faire-dawn-header-section a[href]');
    if(!directLink||!isDirectEditorial(directLink.getAttribute('href')))return;
    event.preventDefault();
    event.stopPropagation();
    if(typeof event.stopImmediatePropagation==='function')event.stopImmediatePropagation();
    window.location.assign(localizePath(directLink.getAttribute('href'))||directLink.href);
  },true);

  (function loadBase(){
    try{
      var current=document.currentScript&&document.currentScript.src;
      if(!current)return;
      var backup=current.replace(/dd-account-newtab\.js(?=\?|$)/,'backup-dd-account-newtab-before-designer-router-20260909.js');
      if(!backup||backup===current)return;
      var script=document.createElement('script');
      script.src=backup;
      script.async=false;
      script.dataset.ddAccountBase='1';
      document.head.appendChild(script);
    }catch(error){console.warn('DD account base loader skipped',error);}
  })();

  // Canonical designer profile collections, shared across all storefront pages.
  var DESIGNERS={
    "adatepe seramik atolyesi":"/collections/tasarimci-adatepe-seramik-atolyesi",
    "altar design studio":"/collections/altar-design-studio",
    "atelier emine":"/collections/tasarimci-atelier-emine",
    "atelier galin":"/collections/tasarimci-atelier-galin",
    "birim erol":"/collections/tasarimci-birim-erol",
    "creamic studio":"/collections/tasarimci-creamic-studio",
    "desyhane wood design workshop":"/collections/desyhane-wood-design-workshop",
    "drag&drop":"/collections/tasarimci-dragdrop",
    "hario":"/collections/tasarimci-hario",
    "hi atolye x potka":"/collections/tasarimci-hi-atolye-x-potka",
    "hmy design":"/collections/tasarimci-hmy-design",
    "kavi living":"/collections/tasarimci-kavi-living",
    "lotus dog house":"/collections/tasarimci-lotus-dog-house",
    "luta design":"/collections/tasarimci-luta-design",
    "mamezon ceramics":"/collections/mamezon-ceramics",
    "molecule roastery & design":"/collections/tasarimci-molecule-roastery-design",
    "molecule ceremic":"/collections/tasarimci-molecule-roastery-design",
    "momiya dreams":"/collections/momiya-dreams",
    "root":"/collections/tasarimci-root",
    "tasarim isler atolyesi":"/collections/tasarim-i̇sler-atolyesi",
    "the north fox":"/collections/tasarimci-the-north-fox",
    "vinterro studio":"/collections/tasarimci-vinterro-studio",
    "vinterro x kiaya":"/pages/tasarimcilar",
    "vinterro x qirqid":"/pages/tasarimcilar",
    "vinterro x w.ecemarangoz":"/collections/tasarimci-vinterro-x-w-ecemarangoz",
    "vinterro x we lighting":"/pages/tasarimcilar"
  };
  var LEGACY_PAGES={
    '/pages/tasarimci-hmy-design':'/collections/tasarimci-hmy-design',
    '/pages/tasarimci-adatepe-seramik-atolyesi':'/collections/tasarimci-adatepe-seramik-atolyesi',
    '/pages/tasarimci-altar-design-studio':'/collections/altar-design-studio',
    '/pages/tasarimci-atelier-emine':'/collections/tasarimci-atelier-emine',
    '/pages/tasarimci-atelier-galin':'/collections/tasarimci-atelier-galin',
    '/pages/tasarimci-creamic-studio':'/collections/tasarimci-creamic-studio',
    '/pages/tasarimci-desyhane-wood-design-workshop':'/collections/desyhane-wood-design-workshop',
    '/pages/tasarimci-kavi-living':'/collections/tasarimci-kavi-living',
    '/pages/tasarimci-lotus-dog-house':'/collections/tasarimci-lotus-dog-house',
    '/pages/tasarimci-luta-design':'/collections/tasarimci-luta-design',
    '/pages/tasarimci-mamezon-ceramics':'/collections/mamezon-ceramics',
    '/pages/tasarimci-momiya-dreams':'/collections/momiya-dreams',
    '/pages/tasarimci-tasarim-i̇sler-atolyesi':'/collections/tasarim-i̇sler-atolyesi',
    '/pages/tasarimci-birim-erol':'/collections/tasarimci-birim-erol',
    '/pages/tasarimci-dragdrop':'/collections/tasarimci-dragdrop',
    '/pages/tasarimci-hario':'/collections/tasarimci-hario',
    '/pages/tasarimci-hi-atolye-x-potka':'/collections/tasarimci-hi-atolye-x-potka',
    '/pages/tasarimci-molecule-roastery-design':'/collections/tasarimci-molecule-roastery-design',
    '/pages/tasarimci-molecule-ceremic':'/collections/tasarimci-molecule-roastery-design',
    '/pages/tasarimci-pera-heykel':'/pages/tasarimcilar',
    '/pages/tasarimci-root':'/collections/tasarimci-root',
    '/pages/tasarimci-the-north-fox':'/collections/tasarimci-the-north-fox',
    '/pages/tasarimci-vinterro-studio':'/collections/tasarimci-vinterro-studio',
    '/pages/tasarimci-vinterro-x-w-ecemarangoz':'/collections/tasarimci-vinterro-x-w-ecemarangoz',
    '/pages/tasarimci-vinterro-x-kiaya':'/pages/tasarimcilar',
    '/pages/tasarimci-vinterro-x-qirqid':'/pages/tasarimcilar',
    '/pages/tasarimci-vinterro-x-we-lighting':'/pages/tasarimcilar'
  };

  function norm(value){
    var text=String(value||'');
    try{text=decodeURIComponent(text);}catch(error){}
    return text.replace(/\+/g,' ').replace(/×/g,'x').replace(/İ/g,'i').replace(/I/g,'ı').toLocaleLowerCase('tr-TR').replace(/ö/g,'o').replace(/ü/g,'u').replace(/ş/g,'s').replace(/ç/g,'c').replace(/ğ/g,'g').replace(/ı/g,'i').replace(/\s+/g,' ').trim();
  }
  function designerUrl(value){
    var target=DESIGNERS[norm(value)]||'';
    return target?localizePath(target):'';
  }
  function targetFromLegacyVendor(href,label){
    try{
      var url=new URL(href,window.location.origin);
      if(!stripLocalePath(url.pathname).includes('/collections/vendors'))return '';
      return designerUrl(url.searchParams.get('q')||label);
    }catch(error){return '';}
  }
  function rewrite(root){
    var scope=root||document;
    scope.querySelectorAll&&scope.querySelectorAll('a[href]').forEach(function(anchor){
      var raw=anchor.getAttribute('href')||'';
      var target=targetFromLegacyVendor(raw,anchor.textContent);
      if(!target){
        try{
          var url=new URL(raw,window.location.origin);
          var mapped=LEGACY_PAGES[stripLocalePath(url.pathname)]||'';
          target=mapped?localizePath(mapped):'';
        }catch(error){}
      }
      if(!target)return;
      anchor.setAttribute('href',target);
      anchor.dataset.ddDesignerProfileLink='true';
    });
  }
  function redirectLegacyLocation(){
    var path=cleanPath(window.location.pathname);
    var basePath=stripLocalePath(path);
    var mapped=LEGACY_PAGES[basePath]||'';
    var target=mapped?localizePath(mapped):'';
    if(!target&&basePath.includes('/collections/vendors')){
      target=designerUrl(new URLSearchParams(window.location.search).get('q'));
    }
    if(!target||cleanPath(target)===path)return false;
    window.location.replace(target);
    return true;
  }
  if(redirectLegacyLocation())return;
  function boot(root){var scope=root||document;rewrite(scope);normalizeDesignerPanelLinks(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});
  else boot(document);
  var observer=new MutationObserver(function(mutations){
    mutations.forEach(function(mutation){
      mutation.addedNodes.forEach(function(node){if(node instanceof Element)boot(node);});
    });
  });
  if(document.documentElement)observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',function(event){boot(event.target||document);});
})();
